/**
 * UGC Home Page carousel header ("Styled By You" + "See All") theme.
 *
 * Realm 1 (SFRA) Garage values: brand `heading` font (GarageNeue on Garage),
 * uppercase, bold. The Dynamite deltas (AzoSans, regular weight, no casing)
 * live in theme/brands/dynamite/components/project/ugc-carousel-header.js.
 */
export default {
    parts: ['header', 'title', 'seeAll'],
    baseStyle: {
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: {base: '12px', lg: '24px'}
        },
        title: {
            color: 'black',
            fontFamily: 'heading',
            fontSize: '16px',
            fontWeight: 'bold',
            lineHeight: 1.2,
            textTransform: 'uppercase'
        },
        seeAll: {
            color: 'black',
            fontFamily: 'heading',
            fontSize: '14px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            textDecoration: 'underline',
            _hover: {textDecoration: 'underline', color: 'black'}
        }
    }
}
